// Whether a graphql-request failure means the credential itself was
// rejected. gqlRequest's client signs the user out on these, so a caller that
// retries on failure must not retry on them.
//
// Its own module, with no imports: gqlRequest.js pulls in the Redux store
// (for the re-login notice), and everything that only needs this check —
// schoolClassroomStorage, and through it useSSOAutoLogin and the authHelpers
// barrel — would otherwise drag the whole reducer tree along with it.
export const isAuthError = (error) =>
  error?.response?.status === 401 ||
  Boolean(error?.message?.includes("Unauthorized")) ||
  Boolean(error?.message?.includes("User must login")) ||
  Boolean(error?.message?.includes("Token invalidated")) ||
  Boolean(error?.message?.includes("Token is revoked"));
